import React, { lazy } from 'react';
import { SettingsMenuReactCodes } from '@widgets/MainLayout/interfaces';
import ClearingBankPage from '@pages/ClearingBankPage';
import OrderPage from '@pages/OrderPage';

const AccountStatement = lazy(() => import('@pages/AccountStatement'));
const BrokerLevelPositionsPage = lazy(() => import('src/pages/BrokerLevelPositionsPage'));
const MainPage = lazy(() => import('@pages/MainPage'));
const AccountsPage = lazy(() => import('@pages/AccountsPage'));
const ACATRequestsPage = lazy(() => import('@pages/ACATRequestsPage'));
const AuditsPage = lazy(() => import('@pages/AuditsPage'));
const TransactionsPage = lazy(() => import('@pages/TransactionsPage'));
const PositionsPage = lazy(() => import('src/pages/PositionsPage'));
const SecuritiesPage = lazy(() => import('@pages/SecuritiesPage'));
const ThresholdPage = lazy(() => import('@pages/ThresholdPage'));
const RIANotificationPage = lazy(() => import('@pages/RIANotificationPage'));
const TradeOrderPage = lazy(() => import('@pages/TradeOrderPage'));
const TradeOrderForm = lazy(() => import('@pages/TradeOrderForm'));
const Current = lazy(() => import('@pages/CurrentPage'));
const UserGroupsPage = lazy(() => import('@pages/UserGroupsPage'));
const UsersPage = lazy(() => import('@pages/UsersPage'));
const DTCMessages = lazy(() => import('@pages/DTCMessagesPage'));
const PaymentRequests = lazy(() => import('@pages/PaymentRequestsPage'));
const UserManagementPage = lazy(() => import('@pages/UserManagementPage'));
const Clients = lazy(() => import('@pages/ClientPage'));
const LoginWizard = lazy(() => import('@pages/LoginWizard'));
const Preferences = lazy(() => import('@pages/Preferences'));
const Send1099 = lazy(() => import('@pages/Send1099'));
const AccountDetails = lazy(() => import('@pages/AccountDetails'));
const Reports = lazy(() => import('src/pages/ReportsPage'));
const MyPortfolioPage = lazy(() => import('@pages/MyPortfolioPage'));
const RIADashboardPage = lazy(() => import('@pages/RIADashboard'));
const OperationsDashboardPage = lazy(() => import('@pages/OperationsDashboard'));
const RIAListingPage = lazy(() => import('@pages/RIAListingPage'));

export const reactComponentsBase: Record<SettingsMenuReactCodes, React.FC> = {
    [SettingsMenuReactCodes.MainPage]: MainPage,
    [SettingsMenuReactCodes.Accounts]: AccountsPage,
    [SettingsMenuReactCodes.Audits]: AuditsPage,
    [SettingsMenuReactCodes.Transactions]: TransactionsPage,
    [SettingsMenuReactCodes.Positions]: PositionsPage,
    [SettingsMenuReactCodes.Securities]: SecuritiesPage,
    [SettingsMenuReactCodes.ThresholdPage]: ThresholdPage,
    [SettingsMenuReactCodes.RIANotificationPage]: RIANotificationPage,
    [SettingsMenuReactCodes.TradeOrderPage]: TradeOrderPage,
    [SettingsMenuReactCodes.TradeOrderForm]: TradeOrderForm,
    [SettingsMenuReactCodes.Current]: Current,
    [SettingsMenuReactCodes.UserGroups]: UserGroupsPage,
    [SettingsMenuReactCodes.Users]: UsersPage,
    [SettingsMenuReactCodes.DTCMessages]: DTCMessages,
    [SettingsMenuReactCodes.ClearingBank]: ClearingBankPage,
    [SettingsMenuReactCodes.ACATRequests]: ACATRequestsPage,
    [SettingsMenuReactCodes.UserManagement]: UserManagementPage,
    [SettingsMenuReactCodes.Clients]: Clients,
    [SettingsMenuReactCodes.Send1099]: Send1099,
    [SettingsMenuReactCodes.AccountDetails]: AccountDetails,
    [SettingsMenuReactCodes.Orders]: OrderPage,
    [SettingsMenuReactCodes.LoginWizard]: LoginWizard,
    [SettingsMenuReactCodes.Preferences]: Preferences,
    [SettingsMenuReactCodes.Reports]: Reports,
    [SettingsMenuReactCodes.BrokerLevelPositions]: BrokerLevelPositionsPage,
    [SettingsMenuReactCodes.MyPortfolioPage]: MyPortfolioPage,
    [SettingsMenuReactCodes.RIADashboardPage]: RIADashboardPage,
    [SettingsMenuReactCodes.OperationsDashboardPage]: OperationsDashboardPage,
    [SettingsMenuReactCodes.RIAListingPage]: RIAListingPage,
    [SettingsMenuReactCodes.AccountStatement]: AccountStatement,
};
